/**
 * Minimal Comment shapes consumed by the ui-library webcomponents.
 *
 * Découplé du client API (`@sgdf/client-v2`) — toute structure portant
 * les champs requis est structurellement assignable.
 */
export const TYPES = [
    'observation',
    'avis',
    'entretien',
    'prep_entretien',
];
/** Equivalent local de l'enum v1 ``TypeEnum`` du client DRF. */
export const CommentTypeEnum = {
    OBSERVATION: 'observation',
    AVIS: 'avis',
    ENTRETIEN: 'entretien',
    PREP_ENTRETIEN: 'prep_entretien',
};
//# sourceMappingURL=comment.types.js.map